import { Routes } from '@angular/router';
import { AppLayoutComponent } from '@cr-bytes/primeng-admin-console';
import { LoginComponent } from './screens/login/login.component';
import { HomeComponent } from './screens/home/home.component';
import { StoresComponent } from './screens/stores/stores.component';
import { GuardService } from './guards/guard.service';
import { StoreDetailsComponent } from './components/store-details/store-details.component';
import { SubscriptionsComponent } from './screens/subscriptions/subscriptions.component';
import { SubscriptionDetailsComponent } from './components/subscription-details/subscription-details.component';
import { CreateSubscriptionComponent } from './components/create-subscription/create-subscription.component';
import { NewPasswordRequireComponent } from './components/new-password-require/new-password-require.component';
import { VirtualAgentsComponent } from './components/virtual-agents/virtual-agents.component';
import { OnvoPaymentsComponent } from './components/onvo-payments/onvo-payments.component';
import { AiTrainingWorkspace } from './components/ai-Training-Workspace/ai-Training-Workspace';
import { AgentSimulatorComponent } from './components/agent-simulator/agent-simulator.component';
import { ReportsComponent } from './components/reports/reports.component';
import { AgentConfigsComponent } from './components/agent-configs/agent-configs.component';
import { InfobipReportsComponent } from './components/infobip-reports/infobip-reports.component';

export const appRoutes: Routes = [
    {
        path: '', component: AppLayoutComponent,
        canActivate: [GuardService],
        children: [
            { path: '', component: HomeComponent},
            { path: 'home', component: HomeComponent},
            { path: 'stores', component: StoresComponent},
            { path: 'store/:id', component: StoreDetailsComponent},
            { path: 'subscriptions', component: SubscriptionsComponent},
            { path: 'subscriptions/add', component: CreateSubscriptionComponent},
            { path: 'subscriptions/:id', component: SubscriptionDetailsComponent},
            { path: 'virtual-agents', component: VirtualAgentsComponent },
            { path: 'payments', component: OnvoPaymentsComponent },
            { path: 'ai-training-workspace', component: AiTrainingWorkspace },
            { path: 'ai-training-workspace/agent-configs', component: AgentConfigsComponent },
            { path: 'agent-simulator', component: AgentSimulatorComponent },
            { path: 'reports', redirectTo: '/reports/agents', pathMatch: 'full' },
            { path: 'reports/agents', component: ReportsComponent },
            { path: 'reports/infobip', component: InfobipReportsComponent }
        ]
    },
    {
        path: 'newPasswordRequire',
        component: NewPasswordRequireComponent },
    {
        path: 'login',
        component: LoginComponent,
    },
    { path: '**', redirectTo: '/' }
];

